import { render, staticRenderFns } from "./ShoppingCartDppOffersView.vue?vue&type=template&id=32930484&scoped=true&"
import script from "./ShoppingCartDppOffersView.vue?vue&type=script&lang=js&"
export * from "./ShoppingCartDppOffersView.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingCartDppOffersView.vue?vue&type=style&index=0&id=32930484&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32930484",
  null
  
)

export default component.exports